import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcabs() {



const cardData = {
  keyword: "Pune to Panvel Cabs",
  heading: "Lotus Cab: Pune to Panvel Cabs",

  headingDescription:
    "Lotus Cab provides reliable and affordable Pune to Panvel cab services for smooth and comfortable outstation travel. Located approximately 110–120 km from Pune, Panvel is a key junction connecting Mumbai, Navi Mumbai, and Konkan routes. Whether you need a one-way drop, round-trip taxi, same-day return, or corporate travel solution, we offer flexible booking options with transparent per kilometer pricing. Our AC sedans and spacious SUVs are well-maintained, sanitized, and driven by professional chauffeurs experienced in expressway and highway travel. Ideal for family trips, business meetings, airport connections, and weekend plans, Lotus Cab ensures punctual pickup and safe journeys. With easy online booking and 24/7 customer support, your Pune to Panvel ride becomes stress-free and comfortable.",

  top: "Top Places to Visit in Panvel with Lotus Cab",

  topPlaces: [
    {
      title: "Karnala Bird Sanctuary",
      description:
        "Karnala Bird Sanctuary is a peaceful natural attraction near Panvel known for its rich bird species and trekking trails. It is ideal for weekend family trips and picnic outings. Many travelers book round-trip taxis from Pune for a refreshing nature escape. Comfortable AC travel ensures relaxed arrival before the trek. Lotus Cab offers flexible waiting options for day tours."
    },
    {
      title: "Karnala Fort",
      description:
        "Karnala Fort is a historic hill fort offering scenic views and trekking experiences. Adventure lovers often plan weekend trips from Pune to explore this location. Sedan and SUV cabs provide smooth highway travel to the base village."
    },
    {
      title: "Ballaleshwar Pali Temple",
      description:
        "Ballaleshwar Temple in Pali, one of the Ashtavinayak temples, is close to Panvel. Devotees frequently book Pune to Panvel cabs as part of spiritual journeys. AC taxis provide comfortable travel for family darshan trips."
    },
    {
      title: "Prabalgad Fort",
      description:
        "Prabalgad Fort is a popular trekking destination near Panvel offering panoramic views. Group tours and weekend travelers often book SUV taxis for this route."
    },
    {
      title: "Pandavkada Waterfalls",
      description:
        "Pandavkada Waterfalls near Panvel is a seasonal attraction especially during monsoon. Same-day return taxi options are ideal for quick nature visits."
    },
    {
      title: "Adai Waterfall",
      description:
        "Adai Waterfall is a peaceful and less crowded spot perfect for family outings and picnic trips from Pune."
    },
    {
      title: "Belapur Fort",
      description:
        "Belapur Fort near Panvel is a historical site ideal for short exploration trips combined with Navi Mumbai visits."
    },
    {
      title: "Panvel City Market",
      description:
        "Panvel’s local market area is known for traditional food and shopping options. Comfortable cab service ensures easy travel within the city."
    }
  ],

  services: [
    {
      name: "Pune to Panvel Cabs",
      description:
        "Lotus Cab offers dependable Pune to Panvel cab services with transparent per kilometer pricing and flexible travel plans. Ideal for one-way drop, round-trip travel, business meetings, and family outings. Our AC sedans and SUVs ensure comfortable highway journeys. Professional drivers are experienced with Mumbai-Pune Expressway routes. 24/7 booking assistance available."
    },
    {
      name: "Pune to Panvel One Way Cab",
      description:
        "Affordable one-way cab service where you pay only for single-side distance. Perfect for airport transfers and relocation travel."
    },
    {
      name: "Pune to Panvel Round Trip Taxi",
      description:
        "Convenient round-trip taxi packages with flexible return timing suitable for weekend trips and corporate visits."
    },
    {
      name: "SUV Cab Pune to Panvel",
      description:
        "Spacious SUV taxi ideal for group travel and family tours with luggage support and comfortable seating."
    },
    {
      name: "Luxury Cab Pune to Panvel",
      description:
        "Premium luxury cab service for executive and business-class travel with high comfort standards."
    },
    {
      name: "Same Day Return Cab Pune to Panvel",
      description:
        "Same-day return cab option perfect for quick meetings, darshan trips, and short weekend outings."
    },
    {
      name: "Online Booking Pune to Panvel",
      description:
        "Easy online cab booking with instant confirmation and secure payment options."
    },
    {
      name: "Corporate Cab Pune to Panvel",
      description:
        "Professional cab solutions for corporate travel, office visits, and employee transport requirements."
    }
  ],

  tableData: [
    ["Pune to Panvel Cabs", "Pune to Panvel One Way Cab"],
    ["Pune to Panvel Round Trip Taxi", "Affordable Cab Pune to Panvel"],
    ["Luxury Cab Pune to Panvel", "SUV Cab Pune to Panvel"],
    ["Sedan Taxi Pune to Panvel", "Family Trip Cab Pune to Panvel"],
    ["Corporate Cab Pune to Panvel", "Weekend Trip Taxi Pune to Panvel"],
    ["AC Cab Pune to Panvel", "Online Booking Pune to Panvel"],
    ["Best Outstation Cab Pune to Panvel", "Per Km Rate Pune to Panvel"],
    ["Same Day Return Cab Pune to Panvel", "Group Tour Cab Pune to Panvel"],
    ["Picnic Cab Pune to Panvel", "Outstation Taxi Service Pune to Panvel"],
    ["Chauffeur Driven Cab Pune to Panvel", "Budget Luxury Cab Pune to Panvel"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear fare structure with no hidden charges ensures affordable and predictable travel cost."
    },
    {
      WhyChooseheading: "Experienced Expressway Drivers",
      WhyChoosedescription:
        "Professional chauffeurs experienced with Mumbai-Pune Expressway ensure safe travel."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Well-maintained air-conditioned sedans and SUVs for long-distance comfort."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and same-day return options available."
    },
    {
      WhyChooseheading: "Ideal for Corporate & Family Travel",
      WhyChoosedescription:
        "Suitable for business meetings, family trips, and weekend outings."
    },
    {
      WhyChooseheading: "Doorstep Pickup Across Pune",
      WhyChoosedescription:
        "Convenient pickup from residential areas, offices, and airport."
    },
    {
      WhyChooseheading: "Luxury & SUV Options",
      WhyChoosedescription:
        "Premium vehicle options available for enhanced travel experience."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock booking assistance and trip coordination support."
    }
  ]
};

const faqData = [
  { question: "What is the distance from Pune to Panvel?", answer: "The distance is approximately 110–120 km and takes around 2.5–3 hours via expressway." },
  { question: "Is one-way taxi available?", answer: "Yes, affordable one-way drop cab service is available." },
  { question: "Are SUV options available?", answer: "Yes, spacious SUV taxis are available for family and group travel." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return taxi service is available." },
  { question: "Is fare calculated per km?", answer: "Yes, transparent per kilometer billing is followed." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are available." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with confirmation is available." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate outstation taxi packages are available." },
  { question: "Are drivers experienced?", answer: "Yes, trained and background-verified chauffeurs ensure safe travel." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer support is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Abhishek Jain",
    feedback:
      "Booked Pune to Panvel cab for corporate meeting. Very punctual driver and smooth expressway travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback:
      "Family trip to Karnala was comfortable with Lotus Cab. Clean vehicle and transparent pricing.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable service for regular business travel between Pune and Panvel. Highly recommended.",
    rating: 5
  }
];


















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panvel Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-panvel-cabs.jpg", 
  "description": "Lotus Cab provides dependable taxi services from Pune to Panvel for one-way trips, round trips, family outings, corporate travel, weekend trips, and group tours. Choose from luxury, SUV, AC, and sedan cabs with chauffeur service, affordable per km rates, same-day return, and hassle-free online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3599",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-panvel-cabs"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Panvel Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to Panvel with Lotus Cab. One-way, round-trip, weekend, family & corporate trips. Luxury, SUV & AC cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Panvel Cabs, Pune to Panvel One Way Cab, Pune to Panvel Round Trip Taxi, Affordable Cab Pune to Panvel, Luxury Cab Pune to Panvel, SUV Cab Pune to Panvel, Sedan Taxi Pune to Panvel, Family Trip Cab Pune to Panvel, Corporate Cab Pune to Panvel, Weekend Trip Taxi Pune to Panvel, AC Cab Pune to Panvel, Online Booking Pune to Panvel, Best Outstation Cab Pune to Panvel, Per Km Rate Pune to Panvel, Same Day Return Cab Pune to Panvel, Group Tour Cab Pune to Panvel, Picnic Cab Pune to Panvel, Outstation Taxi Service Pune to Panvel, Chauffeur Driven Cab Pune to Panvel, Budget Luxury Cab Pune to Panvel" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanvelcabs;